import { call, put, delay } from "redux-saga/effects";
import { sampleApi, subscriptionAPI } from "@services/api";
import { totalSubscriberActions } from "../slices";

function* totalSubscriberWorker({ payload }) {
  //   yield delay(300);
  try {
    yield put(totalSubscriberActions.pending());
    const response = yield call(subscriptionAPI.getTotalSubscriber, payload);
    yield put(totalSubscriberActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(totalSubscriberActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { totalSubscriberWorker };
